module.exports = __webpack_public_path__ + "img/荞麦.e128d290.png";